import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import {
  JobScenario,
  JobViewData,
  PortfolioSet,
  RootState,
  Scenarios,
  ScenarioSet
} from 'interfaces';

import { fetchCalcSetting, fetchScenarioSet, fetchScenario, fetchPortfolio } from 'api';

const initialState: JobViewData = {
  jobName: null,
  portfolioList: [],
  scenarioList: [],
  // @TODO: add Rules
  rulesList: [],
  scenarioSets: [],
  portfolios: [],
  loading: false
};

export const getCalcSettings = createAsyncThunk<any, {
  calcId: number
}, { state: RootState }>(
  'jobView/getCalcSettings',
  async ({ calcId }) => fetchCalcSetting(calcId)
    .then((response: any) => {
      const { name, scenarioSets, portfolios } = response;

      return {
        jobName: name,
        scenarioSets,
        portfolios
      };
    })
);

export const getScenarioSets = createAsyncThunk<any, {
  scenarioSets: ScenarioSet[]
}, { state: RootState }>(
  'jobView/getScenarioSets',
  async ({ scenarioSets }) => {
    const scenarioSetIds = scenarioSets.map((el: ScenarioSet) => el.scenarioSetSerialID);

    return Promise.all(
      [
        ...scenarioSetIds.map((id: number) => fetchScenarioSet(id))
      ]
    )
      .then((responses: Scenarios[]) => {
        const scenarios = responses.map((el: Scenarios) => el.scenarios);

        // @TODO: only unique scenarioSerialID
        const allScenarioIds = scenarios.reduce((acc: number[], current: JobScenario[]) => acc
          .concat(current.map((el: JobScenario) => el.scenarioSerialID)), []);

        return Promise.all(
          [
            ...allScenarioIds.map((id: number) => fetchScenario(id))
          ]
        );
      });
  }
);

export const getPortfolios = createAsyncThunk<any, {
  portfolios: PortfolioSet[]
}, { state: RootState }>(
  'jobView/getPortfolios',
  async ({ portfolios }: any) => {
    const portfoliosIds = portfolios.map((el: any) => el.portfolioSerialID);

    return Promise.all(
      [
        ...portfoliosIds.map((id: number) => fetchPortfolio(id))
      ]
    );
  }
);

const jobVew = createSlice({
  name: 'jobVew',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCalcSettings.pending, (state, action) => ({
        ...state,
        loading: true
      }))
      .addCase(getCalcSettings.fulfilled, (state, action) => {
        const { jobName, scenarioSets, portfolios } = action.payload;

        return {
          ...state,
          jobName,
          scenarioSets,
          portfolios,
          loading: false
        };
      })
      // @TODO: Handle error
      .addCase(getCalcSettings.rejected, (state) => ({
        ...state,
        loading: false
      }))
      .addCase(getScenarioSets.pending, (state) => ({
        ...state,
        loading: true
      }))
      .addCase(getScenarioSets.fulfilled, (state, action) => ({
        ...state,
        scenarioList: action.payload,
        loading: false
      }))
      // @TODO: Handle error
      .addCase(getScenarioSets.rejected, (state) => ({
        ...state,
        loading: false
      }))
      .addCase(getPortfolios.pending, (state) => ({
        ...state,
        loading: true
      }))
      .addCase(getPortfolios.fulfilled, (state, action) => ({
        ...state,
        portfolioList: action.payload,
        loading: false
      }))
      // @TODO: Handle error
      .addCase(getPortfolios.rejected, (state) => ({
        ...state,
        loading: false
      }));
  }
});

export default jobVew.reducer;
